import React, { useEffect, useRef, useState } from "react";
import "../styles/OverallProgressListPendingItems.css";
import OverallAssessmentStart from "../assets/overallAssessmentStart.svg";
import OverallVideoWatch from "../assets/learningImg.png";
import PlayIcon from "../assets/playImg.png";
import FileIcon from "../assets/fileIcon.png";
import { useApi } from "../../../service/ApiContext";
import Loader, { LocalStorage } from "../../../utils/Utils";
import Logger from "../../../utils/Logger";
import { useNavigate } from "react-router-dom";
import strings from "../../../utils/Strings";
import info from "../assets/info 1.svg";

import {
  setAssessmentId,
  setCurrentCounter,
  setDuration,
  setIsIndependent,
  setStatus,
  setTimeSpend,
  setTotalQuestion,
} from "../data/redux/AssessmentSlice";
import { useDispatch, useSelector } from "react-redux";
import NoVideosImg from "../assets/pdfandvideoillustrator.png";
import ActiveAssessmentImg from "../assets/activeAssessment.svg";
import MissedAssessmentImg from "../assets/activeAssessment.svg";
import AllVideosWatchedImg from "../assets/pdfandvideoallwatchedimg.png";
import GreatNoAssessmentImg from "../assets/noMissedAssessment.svg";
import CompletedAllAssImg from "../assets/completedAllAssessment.svg";
import {
  AssessmentResponse,
  SubscriptionResponse,
  TopicVideoResponse,
  VideoResponse,
} from "../data/interface/PendingItemsInteface";
import { RootState } from "../../../store/store";
import { useAlert } from "../../../components/AlertContextComponent";
import CommonUtils from "../../../utils/Common_Utils";
import { LabSessionVideoResponse } from "../data/interface/Topic_video_response";
import RecommendationIndustryViewClient, {
  AssessmentQuestionModuleClient,
} from "../data/client/VideoReportClient";
import TruncatedTextWithTooltip from "./TruncatedTooltip";
import ShimmerLoader from "./ShimmerLoader";
import { Tooltip } from "@mui/material";

interface PendingItem {
  id: string;
  topic_id?: string;
  course_id?: string;
  program_id?: string;
  type: "video" | "assessment";
  title: string;
  action: string;
  status?: "active" | "missed";
  assessment_entity_id?: string;
  assessment_id?: string | null;
  current_counter?: number | null;
  time_spend?: number | null;
  total_question?: number | null;
  assessment_duration?: number | null;
  candidate_assessment_status?: string | null;
  program_category?: "Jozuna" | "Industry";
  is_lab_session?: boolean;
  image?: string;
  assessment_expiry?: string;
  // content_type?: string;
  // program_name?: string;
  // course_name?: string;
  // topic_name?: string;
  assessment_start_time?: string;
  file_title?: string;
  assessment_entity_name?: string;
  dimension_questions?: boolean;
  category_questions?: boolean;
  curriculum_questions?: boolean;
  assessment_entity_time_left?: string;
  category_list?: any[];
  curriculum_list?: any[];
}

interface ApiResponse {
  total_videoes: 20;
  videos: any[]; // You might want to define a proper type for videos
  assessments: {
    total_active: 6;
    total_misses: 6;
    Active: Array<{
      assessment_entity_id: string;
      assessment_entity_name: string;
      status: string;
      assessment_id: string | null;
      current_counter: number | null;
      time_spend: number | null;
      total_question: number | null;
      assessment_duration: number | null;
      candidate_assessment_status: string | null;
    }>;
    Missed: Array<{
      assessment_entity_id: string;
      assessment_entity_name: string;
      status: string;
      assessment_id: string | null;
      current_counter: number | null;
      time_spend: number | null;
    }>;
  };
}
interface OverallProgressProps {
  overallprogressvalue: any;
  isAssessment: boolean;
  isFromLearningRoom?: boolean;
}

const OverallProgressListPendingItems: React.FC<OverallProgressProps> = ({
  overallprogressvalue,
  isAssessment,
  isFromLearningRoom,
}) => {
  const [activeTab, setActiveTab] = useState<"active" | "missed" | "">(
    "active",
  );
  const [videos, setVideos] = useState<any[]>([]);
  const [assessmentsActive, setAssessmentsActive] = useState<any[]>([]);
  const [assessmentsMissed, setAssessmentsMissed] = useState<any[]>([]);

  const [loading, setLoading] = useState(true);
  const [loadingActive, setLoadingActive] = useState(true);

  const [loadingClosed, setLoadingClosed] = useState(true);

  const [videoData, setVideoData] = useState<TopicVideoResponse>();
  const [recommendationVideoData, setRecommendationVideoData] =
    useState<TopicVideoResponse>();

  const api = useApi();
  const navigate = useNavigate();
  const [pendingItems, setPendingItems] = useState<PendingItem[]>([]);
  const [pendingActiveItems, setPendingActiveItems] = useState<PendingItem[]>(
    [],
  );
  const [pendingMissedItems, setPendingMissedItems] = useState<PendingItem[]>(
    [],
  );

  const [pageNumberVideo, setPageNumberVideo] = useState(1);
  const [pageNumberActive, setPageNumberActive] = useState(1);
  const [pageNumberMissed, setPageNumberMissed] = useState(1);

  const [hasMoreVideo, setHasMoreVideo] = useState(true);
  const [hasMoreActive, setHasMoreActive] = useState(true);
  const [hasMoreMissed, setHasMoreMissed] = useState(true);
  const [isIndependent, setIsIndependentuse] = useState<any>();
  const limit = 4;
  const [totals, setTotals] = useState({
    videos: 0,
    active: 0,
    missed: 0,
  });

  const getPendingItemsVideos = async (page: number) => {
    // Loader.showLoading("Loading...");
    setLoading(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      setLoadingMissed(true);

      const response = await api.get<VideoResponse>(
        `/candidate/pending_items?item=Videos&page_number=${page}&limit=${limit}`,
      );

      const { no_of_records, records } = response.data;

      // Build video items

      const videoItems: PendingItem[] = records.map((item) => {
        const isVideo =
          item.content_type === "video" ||
          (!item.content_type && !!item.video_title);

        const isPdf =
          item.content_type === "pdf" ||
          (!item.content_type && !item.video_title && !!item.file_title);

        return {
          id: item.video_id || Math.random().toString(),
          topic_id: item.topic_id,
          course_id: item.course_id,
          program_id: item.program_id,
          program_category: item.program_category,
          image: isVideo ? PlayIcon : FileIcon,
          // keep compatible with PendingItem type
          type: isVideo ? "video" : "assessment", // or existing non-video type

          title: isVideo
            ? item.video_title || "Untitled Video"
            : item.file_title || "Untitled File",

          action:
            item.completion_status === "In Progress"
              ? "Resume"
              : isVideo
                ? "Watch"
                : "Read",

          is_lab_session: item.is_lab_session,
        };
      });

      setPendingItems((prev) => [...prev, ...videoItems]);

      // Pagination stop condition
      if (page * limit >= no_of_records) {
        setHasMoreVideo(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      setHasMoreVideo(false);
    } finally {
      Loader.dismissLoading();
      setLoadingMissed(false);

      setLoading(false);
    }
  };

  const getPendingItemsActiveAssessments = async (page: number) => {
    // Loader.showLoading("Loading...");
    setLoadingActive(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<AssessmentResponse>(
        `/candidate/pending_items?item=Assessments&status=Active&page_number=${page}&limit=${limit}`,
      );
      setAssessmentsActive(response.data.records);
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.isIndependent,
        response.data.is_independent?.toString() ?? "true",
      );
      setIsIndependentuse(response.data.is_independent);
      const activeAssessmentItems: PendingItem[] = response.data.records.map(
        (assessment) => ({
          id: assessment.assessment_entity_id,
          type: "assessment",
          title: assessment.assessment_entity_name,
          action: assessment.status,
          status: "active",
          assessment_entity_id: assessment.assessment_entity_id,
          assessment_id: assessment.assessment_id,
          current_counter: assessment.current_counter,
          time_spend: assessment.time_spend,
          total_question: assessment.total_question,
          assessment_duration: assessment.assessment_duration,
          candidate_assessment_status: assessment.candidate_assessment_status,
          assessment_start_time: assessment.assessment_start_time,
          assessment_expiry: assessment.assessment_expiry,

          // ADD THESE
          assessment_entity_name: assessment.assessment_entity_name,

          dimension_questions: assessment.dimension_questions,

          category_questions: assessment.category_questions,

          curriculum_questions: assessment.curriculum_questions,

          assessment_entity_time_left: assessment.assessment_entity_time_left,

          category_list: assessment.category_list ?? [],

          curriculum_list: assessment.curriculum_list ?? [],
        }),
      );

      setPendingActiveItems((prev) => [...prev, ...activeAssessmentItems]);

      if (
        pendingActiveItems.length + activeAssessmentItems.length >=
        response.data.no_of_records
      ) {
        setHasMoreActive(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      setHasMoreActive(false);
    } finally {
      Loader.dismissLoading();
      setLoadingActive(false);
    }
  };
  const getPendingItemsClosedAssessments = async (page: number) => {
    // Loader.showLoading("Loading...");
    setLoadingClosed(true);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<AssessmentResponse>(
        `/candidate/pending_items?item=Assessments&status=Closed&page_number=${page}&limit=${limit}`,
      );
      setAssessmentsMissed(response.data.records);
      const missedAssessmentItems: PendingItem[] = response.data.records.map(
        (assessment) => ({
          id: assessment.assessment_entity_id,
          type: "assessment",
          title: assessment.assessment_entity_name,
          action: assessment.status,
          status: "missed",
          assessment_entity_id: assessment.assessment_entity_id,
          assessment_id: assessment.assessment_id,
          current_counter: assessment.current_counter,
          time_spend: assessment.time_spend,
        }),
      );

      setPendingMissedItems((prev) => [...prev, ...missedAssessmentItems]);

      if (
        pendingMissedItems.length + missedAssessmentItems.length >=
        response.data.no_of_records
      ) {
        setHasMoreMissed(false);
      }
    } catch (error) {
      Logger.info("error response", error);
      setHasMoreMissed(false);
    } finally {
      Loader.dismissLoading();
      setLoadingClosed(false);
    }
  };
  useEffect(() => {
    if (hasMoreVideo) {
      getPendingItemsVideos(pageNumberVideo);
    }
  }, [pageNumberVideo]);
  useEffect(() => {
    if (activeTab === "active" && hasMoreActive) {
      getPendingItemsActiveAssessments(pageNumberActive);
    }
  }, [pageNumberActive, activeTab]);
  useEffect(() => {
    if (activeTab === "missed" && hasMoreMissed) {
      getPendingItemsClosedAssessments(pageNumberMissed);
    }
  }, [pageNumberMissed, activeTab]);
  const [labData, setLabData] = useState<LabSessionVideoResponse>();

  const getLabTopicVideos = async (
    courseId?: string,
    video_id?: string,
    topic_id?: string,
    program_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    try {
      const response = await api.get<LabSessionVideoResponse>(
        `${RecommendationIndustryViewClient.labSession}?course_id=${courseId}`,
      );
      setLabData(response.data);
      navigate("/dashboard/learning-room/view-labsession/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topic_id, // Videos topic id
          video_list: response.data.videos[0].list_videos, // labData for video thumbnail & video id
          course_name: null, // Course name
          course_id: courseId, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: true, // Indicates it's a lab session
        },
      });
      // labSetSelectedItem(response.data)
    } catch (error) {
      Logger.error("Error fetching Lab Topic Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };
  const getProgram = async (programId?: string) => {
    Loader.showLoading("Loading...");
    setLoading(true);

    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    const param = {
      program_category: "Industry",
    };

    try {
      const response = await api.get<any>("/list_program", param);

      const options = response.data.programs.map((program: any) => ({
        id: program.program_id,
        title: program.program_title,
        description: program.program_description,
      }));

      // Find the matched program using programId
      const matchedProgram = programId
        ? options.find((program: any) => program.id === programId)
        : null;

      if (matchedProgram) {
        return matchedProgram.title;
      }
    } catch (error) {
      Logger.info("error response", error);
    } finally {
      Loader.dismissLoading();
      setLoading(false);
    }

    return null;
  };
  const getTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    const programTitle = await getProgram(program_id);

    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Industry",
        },
      );
      setVideoData(response.data);
      const matchedVideo = response.data?.videos?.[0]?.list_videos?.find(
        (video) => video.video_id === video_id,
      );

      navigate("/dashboard/learning-room/view-courses/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Industry",
          labSession: false, // Indicates it's not a lab session
          //state Header values
          selectedProgramTitle: programTitle,
          selectedTopicTitle: matchedVideo?.topic_title,
        },
      });

      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const getRecommendationTopicVideos = async (
    topicId?: string,
    course_id?: string,
    program_id?: string,
    video_id?: string,
  ) => {
    Loader.showLoading(strings.loading);
    api.setAuthToken(LocalStorage.getLocalData("access_token"));

    try {
      const response = await api.get<TopicVideoResponse>(
        RecommendationIndustryViewClient.getCourseVideoUrl,
        {
          course_id: course_id,
          topic_id: topicId,
          program_id: program_id,
          program_category: "Jozuna",
        },
      );
      setRecommendationVideoData(response.data);
      navigate("/dashboard/recommendation/jozunaview/video", {
        state: {
          video_id: video_id, // For initial video to play
          topic_id: topicId, // Videos topic id
          video_list: response.data?.videos[0].list_videos, // videoData videos
          course_name: null, // Course name
          course_id: course_id, // Course ID
          // course_topic: selectedItem?.topic_title, // Videos topic title
          program_id: program_id,
          program_category: "Jozuna",
          labSession: false, // Indicates it's not a lab session
        },
      });
      // setVideoduration(response.data.total_duration);
    } catch (error) {
      Logger.error("Error fetching Course Videos:", error);
    } finally {
      Loader.dismissLoading();
    }
  };

  const hasVideos = pendingItems.length > 0;
  const { showAlert } = useAlert();
  const hasActiveAssessments = pendingActiveItems.length > 0;
  const hasMissedAssessments = pendingMissedItems.length > 0;

  const dispatch = useDispatch();
  const containerRef = useRef<HTMLDivElement>(null);
  const containerActiveRef = useRef<HTMLDivElement>(null);
  const containerVideoRef = useRef<HTMLDivElement>(null);

  const [loadingMissed, setLoadingMissed] = useState(false);

  const handleScroll = () => {
    if (!containerRef.current) return;

    const { scrollTop, clientHeight, scrollHeight } = containerRef.current;

    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberMissed((prev) => {
        const nextPage = prev + 1;
        Logger.info("Page number incremented to", nextPage);
        return nextPage;
      });
      setLoadingMissed(true); // lock until API finishes
    }
  };

  const handleAciveScroll = () => {
    if (!containerActiveRef.current) {
      Logger.info("pagenumber increament%%%% ", pageNumberActive);

      return;
    }

    const { scrollTop, clientHeight, scrollHeight } =
      containerActiveRef.current;

    // Check if near bottom
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberActive((prev) => prev + 1);
      Logger.info("pagenumber increament ", pageNumberActive);
    }
  };
  const handleVideoScroll = () => {
    if (!containerVideoRef.current) {
      Logger.info("pagenumber increament%%%% ", pageNumberVideo);

      return;
    }

    const { scrollTop, clientHeight, scrollHeight } = containerVideoRef.current;

    // Check if near bottom
    if (scrollTop + clientHeight >= scrollHeight - 5) {
      setPageNumberVideo((prev) => prev + 1);
      Logger.info("pagenumber increament ", pageNumberVideo);
    }
  };
  //Subscription check api
  const checkSubscriptionValidation = async (): Promise<boolean> => {
    api.setAuthToken(LocalStorage.getLocalData("access_token"));
    Loader.showLoading("Loading...");
    try {
      const response = await api.get<SubscriptionResponse>(
        AssessmentQuestionModuleClient.check_subscription,
      );

      const data = response.data;

      if (data.error) {
        showAlert({
          show: true,
          title: "Error",
          message: data.error,
          alertType: "error",
          onlyNeedOneButton: true,
          button1Text: "Cancel",
          btn1onPressed() {},
        });
        return true;
      }

      return false;
    } catch (error) {
      Logger.error("Error fetching assessment status:", error);
      return false;
    } finally {
      Loader.dismissLoading();
    }
  };

  const handleAssessmentClick = async (item: any) => {
    const isIndependentCheck = LocalStorage.getLocalData("isIndependent");
    if (item.action !== "Resume" && isIndependentCheck === "false") {
      //Check Trail Assessment Exceed for Start Assessment
      const subscriptionFailed = await checkSubscriptionValidation();
      if (subscriptionFailed === true) {
        return;
      }
    }
    if (
      item.candidate_assessment_status === strings.assessment_status.initated ||
      item.candidate_assessment_status === strings.assessment_status.inProgress
    ) {
      // Redux dispatch
      dispatch(setAssessmentId(item.assessment_id || ""));
      dispatch(setCurrentCounter(item?.current_counter!));
      dispatch(setDuration(item?.assessment_duration!));
      dispatch(setStatus(item.candidate_assessment_status));
      dispatch(setTimeSpend(item?.time_spend!));
      dispatch(setTotalQuestion(item?.total_question!));
      dispatch(setIsIndependent(isIndependent));

      // LocalStorage
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.duration,
        item?.assessment_duration?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.time_spend,
        item?.time_spend?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details
          .candidate_assessment_status,
        item.candidate_assessment_status,
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.assessment_id,
        item.assessment_id || "",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.current_counter,
        item?.current_counter?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.total_question,
        item?.total_question?.toString() ?? "0",
      );
    } else if (
      item.candidate_assessment_status === strings.assessment_status.notStarted
    ) {
      // Redux dispatch
      dispatch(setDuration(item?.assessment_duration!));
      dispatch(setTotalQuestion(item?.total_question!));
      dispatch(setStatus(item.candidate_assessment_status));
      dispatch(setIsIndependent(isIndependent));

      // LocalStorage
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details.duration,
        item?.assessment_duration?.toString() ?? "0",
      );
      LocalStorage.setLocalData(
        strings.localStorage_keys.assessment_details
          .candidate_assessment_status,
        item.candidate_assessment_status,
      );

      Logger.info("Assessment not started");
    }
    LocalStorage.setLocalData(
      strings.localStorage_keys.assessment_details.assessment_expiry_time,
      item.assessment_expiry.toString(),
    );

    LocalStorage.setLocalData(
      strings.localStorage_keys.assessment_details.assessment_start_time,
      item.assessment_start_time.toString(),
    );
    const warningText = CommonUtils.getAssessmentTimeWarning(item, true);
    if (warningText) {
      showAlert({
        show: true,
        title: "Warning",
        message: warningText,
        alertType: "error",
        onlyNeedOneButton: true,
        button1Text: "Ok",
        btn1onPressed() {
          // Navigate after preparing everything
          navigate("/dashboard/assessment/cameracheck", {
            state: {
              assessmentList: item,
              selectedAssessment: item, // pass selected card
            },
          });
        },
      });
      return;
    } else {
      // Navigate after preparing everything
      navigate("/dashboard/assessment/cameracheck", {
        state: {
          assessmentList: item,
          selectedAssessment: item, // pass selected card
        },
      });
    }
  };
  const profileData = useSelector(
    (state: RootState) => state.profile.profileKeys,
  );
  return (
    <div className="OverallProgressListPending-container">
      {/* Videos Section */}
      {profileData.partner_institute === true && isAssessment === false && (
        <div
          className="OverallProgressListPending-section"
          // style={{ backgroundColor: "#DFF2FF" }}
        >
          <div className="OverallVideoWatchHeader-section">
            {/* <div className="OverallVideoWatchImg-section">
              <img
                className="OverallVideoWatchImg"
                src={OverallVideoWatch}
                alt="Video icon"
              />
            </div> */}
            <div className="OverallProgressListPending-sectionTitle">
              {isFromLearningRoom === true
                ? "Up Next Step"
                : "Learning Contents"}
            </div>
          </div>
          {isFromLearningRoom && (
            <div
              style={{
                height: "2px",
                marginTop: "-30px",
                background: "#EAEAEA",
                // margin: "12px 0",
                width: "100%",
                marginBottom: "10px",
              }}
            />
          )}
          {hasVideos ? (
            <div
              className="OverallProgressListPending-itemsList"
              ref={containerVideoRef}
              style={{
                maxHeight: "210px",
                // backgroundColor: "blue",
                overflowY: "auto",
                scrollbarWidth: "thin",
              }}
              onScroll={handleVideoScroll}
            >
              {pendingItems.map((item) => (
                <div
                  key={item.id}
                  className="OverallProgressListPending-item"
                  style={{ backgroundColor: "#BEDEF3" }}
                >
                  <div className="OverallProgressListPending-titleWrapper">
                    <img
                      src={item.image}
                      alt="content icon"
                      className="OverallProgressListPending-titleIcon"
                      style={{ marginRight: "5px" }}
                    />

                    <TruncatedTextWithTooltip
                      className="OverallProgressListPending-itemTitle"
                      text={item.title}
                    />
                  </div>

                  <button
                    className={`OverallProgressListPending-actionButton ${
                      item.action === "Resume"
                        ? "OverallProgressListPending-resumeButton"
                        : ""
                    }`}
                    onClick={async () => {
                      if (item.program_category === "Industry") {
                        if (item.is_lab_session === true) {
                          await getLabTopicVideos(
                            item.course_id,
                            item.id,
                            item.topic_id,
                            item.program_id,
                          );
                        } else {
                          await getTopicVideos(
                            item.topic_id,
                            item.course_id,
                            item.program_id,
                            item.id,
                          );
                        }
                      } else if (item.program_category === "Jozuna") {
                        await getRecommendationTopicVideos(
                          item.topic_id,
                          item.course_id,
                          item.program_id,
                          item.id,
                        );
                      } else {
                        await getTopicVideos(
                          item.topic_id,
                          item.course_id,
                          item.program_id,
                          item.id,
                        );
                      }
                    }}
                  >
                    {item.action}
                  </button>
                </div>
              ))}
              {loading && (
                <>
                  <ShimmerLoader />
                  <ShimmerLoader />
                  <ShimmerLoader />
                </>
              )}
            </div>
          ) : overallprogressvalue !== 100 ? (
            <div className="Overall-empty-state-container">
              <img src={NoVideosImg} className="Overall-empty-state-img"></img>
              <div className="Overall-empty-state">
                No Learning contents to complete
              </div>
            </div>
          ) : (
            <div className="Overall-empty-state-container">
              <img
                src={AllVideosWatchedImg}
                className="Overall-empty-state-img"
              ></img>
              <div className="Overall-empty-state">
                Hooray! You have completed all the learning contents{" "}
              </div>
            </div>
          )}
        </div>
      )}

      {/* Assessments Section */}
      {isAssessment === true && (
        <div
          className="OverallProgressListPending-section"
          style={{
            // backgroundColor: "#FFF6D8",
            width: "100%",
          }}
        >
          <div className="OverallVideoWatchHeader-section">
            <div className="OverallProgressListPending-sectionTitle">
              Interactive Activities{" "}
            </div>
            <TruncatedTextWithTooltip
              text=""
              className="OverallProgressListPending-sectionTitle"
            ></TruncatedTextWithTooltip>
            <div className="OverallMissedActive-section">
              <div
                className={`OverallMissedToggle ${
                  activeTab === "missed" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("missed");
                  setPendingActiveItems([]);
                  setPendingMissedItems([]);
                  setPageNumberMissed(1);
                  setHasMoreMissed(true);
                  // setAssessments((prev: any) => ({
                  //   ...prev,
                  //   Active: [],
                  // }));
                }}
              >
                Missed
              </div>
              <div
                className={`OverallActiveToggle ${
                  activeTab === "active" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("active");
                  setPendingActiveItems([]);
                  setPageNumberActive(1);
                  setHasMoreActive(true);
                  // setAssessments((prev: any) => ({
                  //   ...prev,
                  //   Missed: [],
                  // }));
                }}
              >
                Active
              </div>
            </div>
          </div>

          {activeTab === "active" && (
            <>
              {hasActiveAssessments ? (
                <div
                  className="OverallProgressListPending-itemsList"
                  ref={containerActiveRef}
                  style={{
                    maxHeight: "210px",
                    // backgroundColor: "blue",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                  }}
                  onScroll={handleAciveScroll}
                >
                  {pendingActiveItems.map((item) => (
                    <div
                      key={item.id}
                      className="OverallProgressListPending-item"
                      style={{ backgroundColor: "#ECDEB0" }}
                    >
                      <TruncatedTextWithTooltip
                        className="OverallProgressListPending-itemTitle"
                        text={item.title}
                      />
                      <button
                        className="OverallProgressListPending-actionButton"
                        style={{ backgroundColor: "#B99A32" }}
                        onClick={() => handleAssessmentClick(item)}
                      >
                        {item.action}
                      </button>
                    </div>
                  ))}
                  {loadingActive && (
                    <>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </>
                  )}
                </div>
              ) : overallprogressvalue !== 100 ? (
                <div className="Overall-empty-state-container">
                  <img
                    src={ActiveAssessmentImg}
                    className="Overall-empty-state-img"
                  />
                  <div className="Overall-empty-state">
                    No active assessments to complete
                  </div>
                </div>
              ) : (
                <div className="Overall-empty-state-container">
                  <img
                    src={CompletedAllAssImg}
                    className="Overall-empty-state-img"
                  />
                  <div className="Overall-empty-state">
                    Great! You have completed all assessments
                  </div>
                </div>
              )}
            </>
          )}

          {activeTab === "missed" && (
            <>
              {hasMissedAssessments ? (
                <div
                  className="OverallProgressListPending-itemsList"
                  ref={containerRef}
                  style={{
                    maxHeight: "210px",
                    // backgroundColor: "blue",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                  }}
                  onScroll={handleScroll}
                >
                  {pendingMissedItems.map((item) => (
                    <div
                      key={item.id}
                      className="OverallProgressListPending-item"
                      style={{ backgroundColor: "#ECDEB0" }}
                    >
                      <TruncatedTextWithTooltip
                        className="OverallProgressListPending-itemTitle"
                        text={item.title}
                      />
                    </div>
                  ))}
                  {loadingClosed && (
                    <>
                      <ShimmerLoader />
                      <ShimmerLoader />
                      <ShimmerLoader />
                    </>
                  )}
                </div>
              ) : overallprogressvalue !== 100 ? (
                <div className="Overall-empty-state-container">
                  <img
                    src={MissedAssessmentImg}
                    className="Overall-empty-state-img"
                  />
                  <div className="Overall-empty-state">
                    No missed assessments
                  </div>
                </div>
              ) : (
                <div className="Overall-empty-state-container">
                  <img
                    src={GreatNoAssessmentImg}
                    className="Overall-empty-state-img"
                  />
                  <div className="Overall-empty-state">
                    Great! You haven’t missed any assessments
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default OverallProgressListPendingItems;
